import templateHtml from './verify-two-factor-authentication.html';

const component = {};

component.template = templateHtml;

component.bindings = {
    twoFactorAuthenticationConfiguration: '<',
    showRememberDevice: '<',
    onVerifyCode: '&',
    onAlternativeOptionSelected: '&',
    useSingleTextBox: '<',
    onRedirectWhenTokenExpired: '&',
    isTwilioServiceEnabled: '<',
    isSmsServiceEnabled: '<',
    isVoiceServiceEnabled: '<',
    isVerifyApiServiceEnabled: '<',
    isSmsVoiceServiceEnabled: '<',
};

const AuthenticationMethod = {
    AuthApp: 3,
    Voice: 2,
    SMS: 1,
};

component.controllerAs = 'vm';

function VerifyTwoFactorAuthenticationController(
    $window,
    $stateParams,
    BdLocalize,
    RedirectToLoginService,
    ALERT_TYPE
) {
    const vm = this;

    vm.AuthenticationMethods = AuthenticationMethod;
    vm.enterCodeDescriptionText = '';
    vm.showVerificationModal = true;
    vm.showHavingTroubleModal = false;
    vm.showHavingTroubleLink = true;
    vm.isCodeExpiredOrIncorrect = false;
    vm.isCodeExpired = false;
    vm.codeNotEntered = false;
    vm.isTooManyAttempts = false;
    vm.twoFactorAuthenticationOptions = [];
    vm.rememberMyDevice = false;
    vm.twoFactorUserSettings = {
        AuthAppVerificationCode: null
    };
    
    vm.isAllPhoneServicesDown = !vm.isSmsServiceEnabled && !vm.isVoiceServiceEnabled && !vm.isVerifyApiServiceEnabled;
    vm.isSmsServiceDown = !vm.isSmsServiceEnabled && !vm.isVerifyApiServiceEnabled;
    vm.isVoiceServiceDown = !vm.isVoiceServiceEnabled && !vm.isVerifyApiServiceEnabled;
    
    vm.showSmsServiceDown = vm.isSmsServiceDown && !vm.isVoiceServiceDown && vm.twoFactorAuthenticationConfiguration.DefaultAuthorizationMethod === 1 && !vm.isSmsVoiceServiceEnabled;
    vm.showVoiceServiceDown = vm.isVoiceServiceDown && !vm.isSmsServiceDown && vm.twoFactorAuthenticationConfiguration.DefaultAuthorizationMethod === 2 && !vm.isSmsVoiceServiceEnabled;
    vm.showAllPhoneServicesDown = vm.isSmsServiceDown && vm.isVoiceServiceDown && vm.twoFactorAuthenticationConfiguration.DefaultAuthorizationMethod !== 3 && !vm.isSmsVoiceServiceEnabled;

    vm.ALERT_TYPE = ALERT_TYPE;
    vm.codeExpiredOrIncorrectMsg = BdLocalize.getString('Public.Login.TwoFactorAuthentication.VerificationCodeErrorMessage', 'Your authentication code expired or was incorrect.');
    vm.codeExpiredMsg = BdLocalize.getString('Public.Login.TwoFactorAuthentication.ResetLinkHasExpired', 'Oops, two-factor authentication has been interrupted. Please try again.');
    vm.codeNotEnteredMsg = BdLocalize.getString('Public.Login.TwoFactorAuthentication.VerificationCodeRequiredErrorMessage', 'You must enter an authentication code.');
    vm.codeTooManyAttemptsMsg = BdLocalize.getString('Public.Login.Login.TooManyMfaAttempts', 'Sorry, we couldn\'t verify your identity. Please try again later.');
    
    const smallScreenMediaQuery = window.matchMedia('(max-width: 600px)');

    if (smallScreenMediaQuery.matches) {
        vm.modalWidth = 340;
    } else {
        vm.modalWidth = 600;
    }

    vm.closeButtonVisible = $stateParams.isMobileApplication ? 'close-button--hidden' : 'close-button--visible';

    function getCodeSentDescriptionText() {
        if (vm.twoFactorAuthenticationConfiguration.DefaultAuthorizationMethod === AuthenticationMethod.AuthApp) {
            // The user has an authenticator app as default authorization method.
            return BdLocalize.getString('Public.Login.TwoFactorAuthentication.AuthAppVerifyIdentityActionDescription',
                'Check your authentication app for a code to sign in.');
        }

        if (vm.twoFactorAuthenticationConfiguration.DefaultAuthorizationMethod === AuthenticationMethod.Voice) {
            // The user has voice call as default authorization method.
            if (vm.twoFactorAuthenticationConfiguration.PrimaryPhoneExtension) {
                // A phone extension has been configured.
                return BdLocalize.getString('Public.Login.TwoFactorAuthentication.ExtensionDetails',
                    `We called ${vm.twoFactorAuthenticationConfiguration.PrimaryPhone}, 
                    Ext.${vm.twoFactorAuthenticationConfiguration.PrimaryPhoneExtension} to provide you with an authentication code.`,
                    [vm.twoFactorAuthenticationConfiguration.PrimaryPhone, vm.twoFactorAuthenticationConfiguration.PrimaryPhoneExtension]);
            } else {
                // No phone extension has been configured.
                return BdLocalize.getString('Public.Login.TwoFactorAuthentication.PhoneCallVerifyIdentityActionDescription',
                    `We called ${vm.twoFactorAuthenticationConfiguration.PrimaryPhone} to provide you with an authentication code.`,
                    [vm.twoFactorAuthenticationConfiguration.PrimaryPhone]);
            }
        }

        // If we reach this point then the user has text message as default authorization method.
        return BdLocalize.getString('Public.Login.TwoFactorAuthentication.TextMessageIdentityActionDescription',
            `We sent a text message with an authentication code to ${vm.twoFactorAuthenticationConfiguration.PrimaryPhone}`,
            [vm.twoFactorAuthenticationConfiguration.PrimaryPhone]);
    }

    function areAlternativeOptionsForTwoFactorAuthenticationAvailable() {
        // If the user has either a primary phone number or a secondary phone number configured
        // then we can provide alternative options for two factor authentication.
        return vm.twoFactorAuthenticationConfiguration
            && (vm.twoFactorAuthenticationConfiguration.PrimaryPhone || vm.twoFactorAuthenticationConfiguration.SecondaryPhone);
    }

    vm.$onInit = function onInit() {
        vm.enterCodeDescriptionText = getCodeSentDescriptionText();
        vm.showHavingTroubleLink = areAlternativeOptionsForTwoFactorAuthenticationAvailable();
    };

    vm.onOverlayClick = function onOverlayClick() {
        // Do nothing here. We don't want users to be able to close the modals when clicking outside them.
    };

    function redirectToLoginPage() {
        RedirectToLoginService.redirect();
    }

    vm.onCancelClick = function onCancelClick() {
        redirectToLoginPage();
    };

    vm.twoFactorAuthCodeEnterPressed = function twoFactorAuthCodeEnterPressed() {
        if (!vm.isCodeExpired) {
            vm.verifyCode();
        }
    };

    vm.twoFactorAuthCodeChanged = function twoFactorAuthCodeChanged() {
        vm.isCodeExpiredOrIncorrect = false;
    };

    vm.evalCodeValidity = function evalCodeValidity(isCodeValid, isCodeExpired, isToManyAttempts) {
        if (isCodeExpired) {
            vm.isCodeExpired = true;
            vm.isCodeExpiredOrIncorrect = false;
        } else if (isToManyAttempts) {
            vm.isCodeExpired = false;
            vm.isCodeExpiredOrIncorrect = false;
            vm.isTooManyAttempts = true;
        } else {
            vm.isCodeExpiredOrIncorrect = isCodeValid === false;
            vm.isCodeExpired = false;
            vm.isTooManyAttempts = false;
        }
    };

    vm.verifyCode = function verifyCode() {
        if (vm.twoFactorUserSettings.AuthAppVerificationCode) {
            vm.codeNotEntered = false;

            vm.onVerifyCode(
                {
                    verificationCode: vm.twoFactorUserSettings.AuthAppVerificationCode,
                    rememberDevice: vm.rememberMyDevice,
                    onCodeVerifiedCallback: vm.evalCodeValidity
                });
        } else {
            vm.codeNotEntered = true;
        }
    };

    vm.tryAgain = function tryAgain() {
        vm.codeNotEntered = false;
        vm.onRedirectWhenTokenExpired();
    };

    function loadAuthenticationOptions() {
        vm.twoFactorAuthenticationOptions = [];

        const phoneCallText = BdLocalize.getString('Public.Login.TwoFactorAuthentication.PhoneCallLabel', 'Phone call');
        const textMessageText = BdLocalize.getString('Public.Login.TwoFactorAuthentication.TextMessageLabel', 'Text message');

        if (vm.twoFactorAuthenticationConfiguration.PrimaryPhone) {
            // The user has a primary phone number configured. We must add the primary phone options.
            let detailsForVoiceCall = vm.twoFactorAuthenticationConfiguration.PrimaryPhone;

            if (vm.twoFactorAuthenticationConfiguration.PrimaryPhoneExtension) {
                detailsForVoiceCall = BdLocalize.getString('Global.Component.Settings.Security.TwoFactorAuthentication.DeliveryMethod.ShortPhoneExtension',
                    `${vm.twoFactorAuthenticationConfiguration.PrimaryPhone}, Ext. ${vm.twoFactorAuthenticationConfiguration.PrimaryPhoneExtension}`,
                    [vm.twoFactorAuthenticationConfiguration.PrimaryPhone, vm.twoFactorAuthenticationConfiguration.PrimaryPhoneExtension]);
            }

            if (vm.isVoiceServiceEnabled || vm.isVerifyApiServiceEnabled || vm.isSmsVoiceServiceEnabled) {
                vm.twoFactorAuthenticationOptions.push({
                    title: phoneCallText,
                    provider: 'Voice',
                    details: detailsForVoiceCall,
                    iconClass: 'verify-two-factor-authentication__having-trouble-image--phone-call',
                    phoneNumber: vm.twoFactorAuthenticationConfiguration.PrimaryPhone,
                    phoneExtension: vm.twoFactorAuthenticationConfiguration.PrimaryPhoneExtension,
                    primaryPhoneNumber: true
                });
            }

            if (vm.isSmsServiceEnabled || vm.isVerifyApiServiceEnabled || vm.isSmsVoiceServiceEnabled) {
                vm.twoFactorAuthenticationOptions.push({
                    title: textMessageText,
                    provider: 'SMS',
                    details: vm.twoFactorAuthenticationConfiguration.PrimaryPhone,
                    iconClass: 'verify-two-factor-authentication__having-trouble-image--text-message',
                    phoneNumber: vm.twoFactorAuthenticationConfiguration.PrimaryPhone,
                    primaryPhoneNumber: true
                });
            }
        }

        if (vm.twoFactorAuthenticationConfiguration.IsAuthAppEnabled) {
            // The user has an authenticator app configured. We must add the option.
            vm.twoFactorAuthenticationOptions.push({
                title: BdLocalize.getString('Public.Login.TwoFactorAuthentication.AuthenticationAppLabel', 'Authentication app'),
                provider: 'AuthApp',
                details: 'Check your authentication app for a code to sign in.',
                iconClass: 'verify-two-factor-authentication__having-trouble-image--auth-app'
            });
        }

        if (vm.twoFactorAuthenticationConfiguration.SecondaryPhone) {
            // The user has a secondary phone number configured. We must add the secondary phone options.
            let detailsForVoiceCall = vm.twoFactorAuthenticationConfiguration.SecondaryPhone;

            if (vm.twoFactorAuthenticationConfiguration.SecondaryPhoneExtension) {
                detailsForVoiceCall = BdLocalize.getString('Global.Component.Settings.Security.TwoFactorAuthentication.DeliveryMethod.ShortPhoneExtension',
                    `${vm.twoFactorAuthenticationConfiguration.SecondaryPhone}, Ext. ${vm.twoFactorAuthenticationConfiguration.SecondaryPhoneExtension}`,
                    [vm.twoFactorAuthenticationConfiguration.SecondaryPhone, vm.twoFactorAuthenticationConfiguration.SecondaryPhoneExtension]);
            }

            vm.twoFactorAuthenticationOptions.push({
                title: phoneCallText,
                provider: 'Voice',
                details: detailsForVoiceCall,
                iconClass: 'verify-two-factor-authentication__having-trouble-image--phone-call',
                phoneNumber: vm.twoFactorAuthenticationConfiguration.SecondaryPhone,
                phoneExtension: vm.twoFactorAuthenticationConfiguration.SecondaryPhoneExtension,
                primaryPhoneNumber: false
            });

            vm.twoFactorAuthenticationOptions.push({
                title: textMessageText,
                provider: 'SMS',
                details: vm.twoFactorAuthenticationConfiguration.SecondaryPhone,
                iconClass: 'verify-two-factor-authentication__having-trouble-image--text-message',
                phoneNumber: vm.twoFactorAuthenticationConfiguration.SecondaryPhone,
                primaryPhoneNumber: false
            });
        }
    }

    vm.onHavingTroubleClick = function onHavingTroubleClick() {
        loadAuthenticationOptions();
        vm.showVerificationModal = false;
        vm.showHavingTroubleModal = true;
    };

    vm.askForCode = function askForCode() {
        vm.showVerificationModal = true;
        vm.showHavingTroubleModal = false;
    };

    function getCodeSentDescriptionTextForSelectedOption(option) {
        if (option.phoneNumber) {
            // An option with a phone number was selected.
            if (option.provider === 'SMS') {
                return BdLocalize.getString('Public.Login.TwoFactorAuthentication.TextMessageIdentityActionDescription',
                    `We sent a text message with an authentication code to ${option.phoneNumber}`,
                    [option.phoneNumber]);
            } else if (option.phoneExtension) {
                return BdLocalize.getString('Public.Login.TwoFactorAuthentication.ExtensionDetails',
                    `We called ${option.phoneNumber}, 
                    Ext.${option.phoneExtension} to provide you with an authentication code.`,
                    [option.phoneNumber, option.phoneExtension]);
            } else {
                return BdLocalize.getString('Public.Login.TwoFactorAuthentication.PhoneCallVerifyIdentityActionDescription',
                    `We called ${option.phoneNumber} to provide you with an authentication code.`,
                    [option.phoneNumber]);
            }
        }

        return BdLocalize.getString('Public.Login.TwoFactorAuthentication.AuthAppVerifyIdentityActionDescription',
            'Check your authentication app for a code to sign in.');
    }

    vm.onClickAlternativeOption = function onClickAlternativeOption(option) {
        vm.enterCodeDescriptionText = getCodeSentDescriptionTextForSelectedOption(option);
        if (option.phoneNumber) {
            // We only send a code when a phone option is selected.
            vm.onAlternativeOptionSelected({option, onSuccessCallback: vm.askForCode});
        } else {
            // An authenticator app was selected.
            vm.askForCode();
        }
    };
}

VerifyTwoFactorAuthenticationController.$inject = [
    '$window',
    '$stateParams',
    'BdLocalize',
    'RedirectToLoginService',
    'ALERT_TYPE'
];
component.controller = VerifyTwoFactorAuthenticationController;
export const VerifyTwoFactorAuthenticationComponent = component;
